import React, { useEffect, useState } from "react";
import { AiFillCaretDown, AiFillCaretRight } from "react-icons/ai";
import { MdKeyboardArrowRight, MdKeyboardArrowDown } from "react-icons/md";
import {
  SideBarActiveCount,
  SideBarNormalCount,
  SideBarNormalDivButtonNew,
  SideBarActiveDivButtonNew,
  SideBarShowcase,
} from "../../pages/Theme";
import { MdOutlinePublic, MdArrowRight, MdArrowLeft } from "react-icons/md";
import { IoMdLock } from "react-icons/io";
import {
  ActiveIconColor,
  ButtonCommonTop,
  TextGray,
  TextGreen,
  ShowCaseDiv,
  PublishIcon,
} from "../../pages/Theme";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { tokenAuthorize, trimString } from "../Helpers/Common";
const SidebarShowcase = ({ data, selectedId, index, setPage }) => {
  const Tab = ({ name, count, published }) => {
    let style =
      "text-base font-medium cursor-pointer flex items-center w-full justify-between  w-full p-2";

    const Wrapper =
      selectedId === index
        ? SideBarActiveDivButtonNew
        : SideBarNormalDivButtonNew;

    return (
      <Wrapper className={style}>
        <div
          className="flex gap-2 justify-between w-full items-center"
          title={name}
        >
          <div className="flex gap-2 items-center">
            {published ? (
              <MdOutlinePublic className="w-6 h-6 primaryIcon" />
            ) : (
              <IoMdLock className="w-6 h-6 secondaryIcon" />
            )}
            <span className={`${selectedId !== index && "lightColor"}`}>
              {trimString(name, 25)}
            </span>
          </div>

          {selectedId === index ? (
            <SideBarActiveCount className="inline-flex items-center justify-center p-1 text-center text-xs w-5 h-5">
              {count}
            </SideBarActiveCount>
          ) : (
            <SideBarNormalCount className="inline-flex flex-shrink-0 items-center justify-center p-1 text-center text-xs w-5 h-5">
              {count}
            </SideBarNormalCount>
          )}
        </div>
        <div>
          {/* {selectedId === index ? (
                        <MdKeyboardArrowDown className="primaryIcon" size={20} />
                    ) : (
                        <MdKeyboardArrowRight className="primaryIcon" size={20} />
                    )} */}
          {/* <MdKeyboardArrowRight className="primaryIcon" size={20} /> */}
        </div>
      </Wrapper>
    );
  };

  return (
    <div className="py-1">
      <div className="flex items-center justify-between cursor-pointer">
        <div className="w-full" onClick={() => setPage(index)}>
          <Tab
            name={data?.name}
            count={data?.posts?.length || 0}
            published={data?.published}
          />
        </div>
      </div>

      {/* {selectedId === index && (
                <div className='flex flex-col flex-1 mt-2 border-left-f1 ml-1 pl-2'>
                    {data.posts?.map((item, postIndex) => (
                        <SideBarShowcase
                            type="button"
                            key={postIndex}
                            className="text-sm gap-2 flex items-center text-left whitespace-normal lightColor p-2 mb-1 w-full cursor-pointer font-medium"
                            value={item.id}
                            title={item.title}
                        >
                            {trimString(item?.title, 30)}
                        </SideBarShowcase>
                    ))}
                </div>
            )} */}
    </div>
  );
};
export default SidebarShowcase;
